// gcp-wif holds only Workload Identity Pool config (see components.ts) and
// has no accesses of its own: granting to a WIF principal reuses gcloud's
// own addMember/removeMember, unlike AWS's pooled-role + runtime condition.
export const GcpWifAccesses = {};

export type GcpWifAccesses = typeof GcpWifAccesses;
